/**
* MPF CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the MPF CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'mpf-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.mpf-cta' ).each( function( key, component ) {
        const topSplide = new Splide( $( component ).find( '.splide--mpf-cta--top' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '24px',
          autoWidth: true,
          drag: false,
          speed: 2000,
          autoScroll: {
            speed: 0.5,
            pauseOnHover: false,
          },
        } );

        topSplide.mount( {AutoScroll} );

        const bottomSplide = new Splide( $( component ).find( '.splide--mpf-cta--bottom' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '24px',
          autoWidth: true,
          drag: false,
          speed: 2000,
          autoScroll: {
            speed: -0.5,
            pauseOnHover: false,
          },
        } );

        bottomSplide.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'mpf-cta', COMPONENT );
} )( app );
